<template>
    <div>
        <total-balances />

        <div class="window white">
            <fieldset>
                <legend>External stats dashboards</legend>
                <div class="links">
                    <a href="https://dune.com/mrblock_buidl/Curve.fi" target="_blank" rel="noopener noreferrer">Dune
                        dashboard ↗</a>
                    <a href="https://llama.airforce/#/curve/" target="_blank" rel="noopener noreferrer">Llama Airforce
                        ↗</a>
                    <a href="https://dune.com/blockworks_research/crv" target="_blank"
                        rel="noopener noreferrer">Blockworks Dune dashboard ↗</a>
                </div>
            </fieldset>
        </div>
    </div>
</template>

<script>
import Vue from 'vue'
import TotalBalances from './TotalBalances.vue'

export default {
    metaInfo: {
        title: 'Curve.finance - Stats',
        meta: [
            { 'property': 'og:url', 'content': 'https://classic.curve.finance/combinedstats' },
            { 'name': 'twitter:url', 'content': 'https://classic.curve.finance/combinedstats' },
        ]
    },
    components: {
        TotalBalances,
    }
}
</script>

<style>
.links {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
}

.links>a {
    background-color: #6c6c6c;
    padding: 10px 20px;
    color: #fff;
    text-align: center;
    opacity: .95;
}

.links>a:hover {
    opacity: 1;
}
</style>
